import React from "react";
import CheckCircleIcon from "mdi-react/CheckCircleIcon";
import { _capitalizeText } from "../../../../../../shared/helpers/utils";

const Amenities = ({ data, icon = false, isAdditional }) => {
  {
    console.log(data, "dataAmenties");
  }
  return (
    <div className="amenities-container">
      <div
        className={`${
          isAdditional
            ? "building-view-additional-amenities"
            : "building-view-amentities"
        }`}
      >
        {data.map((item, index) => (
          <div key={index} className="amenities-wrapper">
            {<span className="checkmark">{item.icon}</span>}
            <span>{_capitalizeText(item.name)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Amenities;
